import styles from "../ContestBanner/ContestBanner.module.scss"
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";

import axios from "axios";
import {setContestId} from "../../NewYearEvent/eventSlice";
import Loader from "../../../subsidiary/Loader/Loader";
import GoBack from "../../../subsidiary/GoBack/GoBack";
import {fetchContest} from "../contestSlice";
const ContestPage = () => {
    // const [contest, setContest] = useState(null);
    const contestId = localStorage.getItem('contestID')
    const dispatch = useDispatch()
    const token = useSelector(state => state.loginSlice.token)
    const navigate = useNavigate()
    const contest = useSelector(state => state.contestSlice.contest)
    const loading = useSelector(state => state.contestSlice.contestLoading)


    useEffect(() => {
        if (token) {
            dispatch(fetchContest({token, contestId}));
        }else {
            console.log("No Token")
        }
    }, [token, contestId, dispatch]);



    function formatDate(isoString) {
        const date = new Date(isoString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}.${month}.${year}`;
    }
    const handleNextPage = () => {
       if(contest?.user_team?.media[0]?.id){
        navigate('/success')
       }else{
        navigate('/chooseTopic')
       }
    }

    
    return (

        <section className='main'>
            {loading ? <Loader/>
                : contest ? (<div className='content-wrapper'>
                    <GoBack nav={'/'} text={'На главную'}/>
                    <div className={styles.contestContainer}>
                        <div className={styles.contestDescription}>
                            <h1 className={styles.contestHeading}>Конкурс «{contest?.name}»</h1>
                            <p className={styles.contestText}>Сбор заявок</p>
                            <p className={styles.contestDate}>
                                с {formatDate(contest?.starts_at)}<br/>по {formatDate(contest?.ends_at)}
                            </p>
                            <button
                                onClick={handleNextPage}
                                className={styles.contestBtn}>
                                Участвовать
                            </button>
                        </div>
                        <div className={styles.imgContainer}>
                            <img src={contest?.image?.image} alt="Конкурс" className={styles.contestImg}/>
                        </div>
                    </div>
                    <div className={styles.conditionContainer}>
                        <p className={styles.conditionText}>Условия</p>
                        <p className={styles.conditionDescription}>
                            <div dangerouslySetInnerHTML={{__html: contest?.terms.toString()}}></div>
                        </p>
                        <div className={styles.btnContainer}>
                            <button
                                className={styles.conditionBtn}
                                onClick={handleNextPage}
                            >
                                Участвовать
                            </button>
                        </div>
                    </div>
                </div>) : <div>-</div>

            }
        </section>
    )
}

export {ContestPage}
